import { useState } from 'react';

/**
 * Submit lifecycle for form dialogs: busy flag, surfaced error, close on success.
 * The thrown error's message is what the API returned (services rethrow it).
 */
export default function useDialogSubmit(onClose: () => void) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const submit = async (fn: () => Promise<void>) => {
    setBusy(true); setError('');
    try { await fn(); onClose(); } catch (e: any) { setError(e.message); } finally { setBusy(false); }
  };
  return { busy, error, submit };
}
